import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 ${({ theme }) => theme.colors.textQuote(0.5)};
  color: ${({ theme }) => theme.colors.textQuote()};
  margin: 0 auto;
  max-width: 960px;
  padding: 0 20px 20px;

  :not(.static) {
    top: -40px;
    position: relative;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.minWidth.S}) {
    padding: 20px 40px 40px;
  }
`;

export const Document = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;

  a {
    margin-top: 15px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.minWidth.S}) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 0;

    a {
      margin-top: 0;
    }
  }
`;

export const Documents = styled.div`
  background-color: ${({ theme }) => theme.colors.textQuote(0.05)};
  border-radius: 2px;
  margin-top: 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.minWidth.XS}) {
    padding: 20px 40px;
    margin-top: 40px;
  }

  > div + div {
    border-top: 0.5px solid ${({ theme }) => theme.colors.textQuote(0.2)};
  }
`;
